import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Checkbox from "../../../shared/checkbox";
import Close from "./images/close.svg";
import getAppliedFilter from "../../../../utils/filters-v2/get-applied-filter";

const PopularBrandPopupContent = ({selectedMake, appliedFilters, isAllOptionSelected, isAnyOptionSelected, handleClose, config, onChangeAllSubOptions, onChangeSubFilterOption}) => {
    const filterKey = "make";
    const {key: makeKey, displayText, count, logo, subFilter} = selectedMake;
    const {options} = subFilter || {};
    const {brandImageHost } = config || {};
    // const isMakeSelected = !!getAppliedFilter({filterKey, optionKey: makeKey}, appliedFilters);

    return (
        <div styleName={"styles.innerContentWrap"}>
            <div styleName={"styles.headerWrapper"} >
                <div styleName={`styles.checkboxWrapper ${isAnyOptionSelected ? "styles.partialChecked" : ""}`}>
                    <Checkbox checkedStatus={isAllOptionSelected} id={makeKey} onChange={() => onChangeAllSubOptions(makeKey, !isAllOptionSelected)}/>
                    <div styleName={"styles.imageWrapper"}>
                        <img src={brandImageHost + logo.dropdownImageUrl} />
                    </div>
                    <p styleName={"styles.brandName"}>{displayText}</p>
                </div>
                <p styleName={"styles.topCarCount"}>{count}</p>
                <div styleName={"styles.closeWrapper"}>
                    <img src={Close} onClick={handleClose} />
                </div>
            </div>
            <div styleName={"styles.contentWrapper"}  >
                <div styleName={"styles.checkboxWrapper"}>
                    <Checkbox checkedStatus={isAllOptionSelected} id={makeKey} onChange={() => onChangeAllSubOptions(makeKey, !isAllOptionSelected)}/>
                    <p styleName={"styles.allModel"}>All Models</p>
                </div>
                <p styleName={"styles.carCount"}>{count}</p>
            </div>
            {options.map((item, index) => {
                const isSelected = !!getAppliedFilter({filterKey, optionKey: makeKey, subOptionKey: item.key}, appliedFilters);
                return (
                    <div styleName={"styles.contentWrapper"} key={item.key} >
                        <div styleName={"styles.checkboxWrapper"}>
                            <Checkbox checkedStatus={isSelected} id={`option_${index}_${item.key}`} onChange={() => onChangeSubFilterOption(filterKey, makeKey, item.key, !isSelected, item.displayText)}/>
                            <p styleName={"styles.carAvailable"}>{item.displayText}</p>
                        </div>
                        <p styleName={"styles.carCount"}>{item.count}</p>
                    </div>
                );
            }
            )}
        </div>
    );
};

PopularBrandPopupContent.propTypes = {
    selectedMake: PropTypes.object,
    popularMakes: PropTypes.object,
    appliedFilters: PropTypes.array,
    handleSelect: PropTypes.func,
    isAllOptionSelected: PropTypes.bool,
    isAnyOptionSelected: PropTypes.bool,
    handleClose: PropTypes.func,
    config: PropTypes.object,
    onChangeAllSubOptions: PropTypes.func,
    onChangeSubFilterOption: PropTypes.func
};

export default PopularBrandPopupContent;
